import Vue from 'vue'
import Vuex from 'vuex'
import {getModule} from "vuex-module-decorators";
import AlertModule from "@/store/modules/alert";
import AuthModule from "@/store/modules/core/auth";
import CurrentUserModule from "@/store/modules/core/current.user";
import RolesModule from "@/store/modules/core/roles";
import RightsModule from "@/store/modules/core/rights";
import UsersModule from "@/store/modules/core/users";
import AuditTrailModule from "@/store/modules/core/audittrail";
import PatientModule from "@/store/modules/core/patient";
import InstituteModule from "@/store/modules/core/institute";
import InstituteAssignmentModule from "@/store/modules/core/institute.assignment";
import InstrumentModule from "@/store/modules/eCRF/instrument";
import StudyDefinitionModule from "@/store/modules/eCRF/study.definition";
import VisitModule from "@/store/modules/eCRF/visit";
import StudyPatientModule from "@/store/modules/eCRF/study.patient";
import LanguageModule from "@/store/modules/eCRF/language";
import DataFieldsEditModule from "@/store/modules/eCRF/data.fields.edit";
import StudyInstitutesModule from "@/store/modules/eCRF/study.institutes";
import StudyModule from "@/store/modules/eCRF/study";
import StudiesModule from "@/store/modules/eCRF/studies";
import StudyPatientsModule from "@/store/modules/eCRF/study.patients";
import StudyPatientContextModule from "@/store/modules/eCRF/study.patient.context";
import SynQuestInterviewModule from "@/store/modules/eCRF/synquest";
import UtilityModule from "@/store/modules/core/utility";
import SafetyModule from "@/store/modules/eCRF/safety";
import ExportsModule from "@/store/modules/eCRF/exports";
import AppSettingsModule from "@/store/modules/core/app.settings";
import NtdInstitutesModule from "@/store/modules/eCRF/ntd.institutes";
import NtdUsersModule from "@/store/modules/eCRF/ntd.users";
import NtdPatientsModule from "@/store/modules/eCRF/ntd.patients";

import DocumentationModule from "@/store/modules/core/documentation";
import QueryModule from "@/store/modules/eCRF/query";
import DocumentModule from "@/store/modules/core/document";
import DataVisualizationModule from "@/store/modules/eCRF/data.visualization";
import DataMigrationModule from "@/store/modules/eCRF/data.migration";
import StudyDefinitionAdminModule from "@/store/modules/eCRF/study.definition.admin";

Vue.use(Vuex)

const store = new Vuex.Store({
    strict: process.env.NODE_ENV !== 'production',
    modules: {
        alert: AlertModule,
        auditTrail: AuditTrailModule,
        auth: AuthModule,
        currentUser: CurrentUserModule,
        dataFieldsEdit: DataFieldsEditModule,
        document: DocumentModule,
        documentation: DocumentationModule,
        users: UsersModule,
        patient: PatientModule,
        institute: InstituteModule,
        instituteAssignment: InstituteAssignmentModule,
        studyDefinition: StudyDefinitionModule,
        studyPatient: StudyPatientModule,
        studyPatientContext: StudyPatientContextModule,
        studyPatients: StudyPatientsModule,
        studyInstitutes: StudyInstitutesModule,
        synQuestInterview: SynQuestInterviewModule,
        visit: VisitModule,
        instrument: InstrumentModule,
        language: LanguageModule,
        roles: RolesModule,
        rights: RightsModule,
        study: StudyModule,
        studies: StudiesModule,
        utility: UtilityModule,
        safety: SafetyModule,
        exports: ExportsModule,
        appSettings: AppSettingsModule,
        ntdInstitutes: NtdInstitutesModule,
        ntdUsers: NtdUsersModule,
        ntdPatients: NtdPatientsModule,
        query: QueryModule,
        dataVisualization: DataVisualizationModule,
        dataMigration: DataMigrationModule,
        studyDefinitionAdmin: StudyDefinitionAdminModule
    }
})

export default store
export const alertModule = getModule(AlertModule, store);
export const appSettingsModule = getModule(AppSettingsModule, store);

// Core modules
export const authModule = getModule(AuthModule, store);
export const currentUserModule = getModule(CurrentUserModule, store);
export const documentationModule = getModule(DocumentationModule, store);
export const rolesModule = getModule(RolesModule, store);
export const rightsModule = getModule(RightsModule, store);
export const usersModule = getModule(UsersModule, store);
export const auditTrailModule = getModule(AuditTrailModule, store);
export const instituteAssignmentModule = getModule(InstituteAssignmentModule, store);
export const instituteModule = getModule(InstituteModule, store);
export const utilityModule = getModule(UtilityModule, store)
export const documentModule = getModule(DocumentModule, store)

// eCRF modules
export const studyModule = getModule(StudyModule, store)
export const studiesModule = getModule(StudiesModule, store)
export const studyDefinitionModule = getModule(StudyDefinitionModule, store)
export const studyInstitutesModule = getModule(StudyInstitutesModule, store)
export const studyPatientModule = getModule(StudyPatientModule, store)
export const studyPatientsModule = getModule(StudyPatientsModule, store)
export const synQuestInterviewModule = getModule(SynQuestInterviewModule, store)
export const visitModule = getModule(VisitModule, store)
export const instrumentModule = getModule(InstrumentModule, store)
export const languageModule = getModule(LanguageModule, store)
export const dataFieldsEditModule = getModule(DataFieldsEditModule, store)
export const studyPatientContext = getModule(StudyPatientContextModule, store)
export const safetyModule = getModule(SafetyModule, store)
export const exportsModule = getModule(ExportsModule, store)
export const ntdInstitutesModule = getModule(NtdInstitutesModule, store)
export const ntdUsersModule = getModule(NtdUsersModule, store)
export const ntdPatientsModule = getModule(NtdPatientsModule, store)
export const queryModule = getModule(QueryModule, store)
export const dataVisualizationModule = getModule(DataVisualizationModule, store)
export const dataMigrationModule = getModule(DataMigrationModule, store)
export const studyDefinitionAdminModule = getModule(StudyDefinitionAdminModule, store)
